<template lang="pug">
div
  b-form-group(:label="$t('ui.english')").mb-1
    DebounceInput(
      size="sm"
      ref="data_en"
      required
      type="text"
      :dirty="$v.data_en.$dirty"
      :error="$v.data_en.$error"
      v-model.trim.lazy="$v.data_en.$model"
      :disabled="loading"
      :class="inputClass"
    )
    ValidateResult(:value="$v.data_en" :name="$t('ui.' + fieldName) + ' ' + $t('ui.english')")
  b-form-group(:label="$tc('ui.simplified_chinese')").mb-1
    DebounceInput(
      size="sm"
      ref="data_cn"
      required
      type="text"
      v-model.trim.lazy="data_cn"
      :disabled="loading"
      :class="inputClass"
    )
    ValidateResult(:value="$v.data_cn" :name="$t('ui.' + fieldName) + ' ' + $t('ui.simplified_chinese')")
  b-form-group(:label="$tc('ui.traditional_chinese')").mb-1
    DebounceInput(
      size="sm"
      ref="data_tw"
      required
      type="text"
      v-model.trim.lazy="data_tw"
      :disabled="loading"
      :class="inputClass"
    )
    ValidateResult(:value="$v.data_tw" :name="$t('ui.' + fieldName) + ' ' + $t('ui.traditional_chinese')")
  b-form-group(:label="$tc('ui.philippine')").mb-1
    DebounceInput(
      size="sm"
      ref="data_ph"
      required
      type="text"
      v-model.trim.lazy="data_ph"
      :disabled="loading"
      :class="inputClass"
    )
    ValidateResult(:value="$v.data_ph" :name="$t('ui.' + fieldName) + ' ' + $t('ui.philippine')")
  b-form-group(:label="$tc('ui.thai')").mb-1
    DebounceInput(
      size="sm"
      ref="data_th"
      required
      type="text"
      v-model.trim.lazy="data_th"
      :disabled="loading"
      :class="inputClass"
    )
    ValidateResult(:value="$v.data_th" :name="$t('ui.' + fieldName) + ' ' + $t('ui.thai')")
  b-form-group(:label="$tc('ui.vietnamese')").mb-1
    DebounceInput(
      size="sm"
      ref="data_vi"
      required
      type="text"
      v-model.trim.lazy="data_vi"
      :disabled="loading"
      :class="inputClass"
    )
    ValidateResult(:value="$v.data_vi" :name="$t('ui.' + fieldName) + ' ' + $t('ui.vietnamese')")
  b-form-group(:label="$tc('ui.indonesian')").mb-1
    DebounceInput(
      size="sm"
      ref="data_id"
      required
      type="text"
      v-model.trim.lazy="data_id"
      :disabled="loading"
      :class="inputClass"
    )
    ValidateResult(:value="$v.data_id" :name="$t('ui.' + fieldName) + ' ' + $t('ui.indonesian')")
  b-form-group(:label="$tc('ui.myanmar')").mb-1
    DebounceInput(
      size="sm"
      ref="data_my"
      required
      type="text"
      v-model.trim.lazy="data_my"
      :disabled="loading"
      :class="inputClass"
    )
    ValidateResult(:value="$v.data_my" :name="$t('ui.' + fieldName) + ' ' + $t('ui.myanmar')")
  b-form-group(:label="$tc('ui.japanese')").mb-1
    DebounceInput(
      size="sm"
      ref="data_jp"
      required
      type="text"
      v-model.trim.lazy="data_jp"
      :disabled="loading"
      :class="inputClass"
    )
    ValidateResult(:value="$v.data_jp" :name="$t('ui.' + fieldName) + ' ' + $t('ui.japanese')")
  b-form-group(:label="$tc('ui.korean')").mb-1
    DebounceInput(
      size="sm"
      ref="data_kr"
      required
      type="text"
      v-model.trim.lazy="data_kr"
      :disabled="loading"
      :class="inputClass"
    )
    ValidateResult(:value="$v.data_kr" :name="$t('ui.' + fieldName) + ' ' + $t('ui.korean')")
//- b-form-select(
//-   :value="value"
//-   :size="size"
//-   :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
//-   @input="handleInput"
//-   )
//-   option(v-if="!haveAll" value="" disabled selected) {{ $t("message.select_option") }}
//-   option(v-else value="" selected) {{ $t("ui.all") }}
//-   option(v-for="option in options" :value="option.provider_code") {{ option.provider_name }} ({{ option.provider_code }})
</template>

<script>
// import config from "@/config";

import { required, alphaNum, minLength, maxLength } from "vuelidate/lib/validators";
// import errorTags from "@/errorTags";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";


export default {
  components: {
    ValidateResult,
    DebounceInput
  },
  props: {
    name: {
      type: Object
    },
    fieldName: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    }
    // value: {
    //   type: String,
    //   default: ""
    // },
    // size: {
    //   type: String,
    //   default: "md"
    // },
    // dirty: {
    //   type: Boolean,
    //   default: false
    // },
    // error: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      loading: false,
      data_en: '',
      data_cn: '',
      data_tw: '',
      data_ph: '',
      data_th: '',
      data_vi: '',
      data_id: '',
      data_my: '',
      data_jp: '',
      data_kr: '',
      disable_en : false
    }
  },
  validations: {
    data_en: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(20)
    },
    data_cn: {
      maxLength: maxLength(20)
    },
    data_tw: {
      maxLength: maxLength(20)
    },
    data_ph: {
      maxLength: maxLength(20)
    },
    data_th: {
      maxLength: maxLength(20)
    },
    data_vi: {
      maxLength: maxLength(20)
    },
    data_id: {
      maxLength: maxLength(20)
    },
    data_my: {
      maxLength: maxLength(20)
    },
    data_jp: {
      maxLength: maxLength(20)
    },
    data_kr: {
      maxLength: maxLength(20)
    },
  },
  watch: {
    name: {
      immediate: true,
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          if(newVal) {
            this.data_en = newVal.en;
            this.data_cn = newVal.cn;
            this.data_tw = newVal.tw;
            this.data_ph = newVal.ph;
            this.data_th = newVal.th;
            this.data_vi = newVal.vi;
            this.data_id = newVal.id;
            this.data_my = newVal.my;
            this.data_jp = newVal.jp;
            this.data_kr = newVal.kr;
            this.disable_en = newVal.disable_en;
          }
        });
      }
    }
  },
  mounted() {
  },
  methods: {
    // handleInput(e) {
    //   this.$emit("input", e);
    // },
    passValue: function(valueObj) {
      this.data_en = valueObj.en;
      this.data_cn = valueObj.cn;
      this.data_tw = valueObj.tw;
      this.data_ph = valueObj.vi;
      this.data_th = valueObj.th;
      this.data_vi = valueObj.vi;
      this.data_id = valueObj.id;
      this.data_my = valueObj.my;
      this.data_jp = valueObj.jp;
      this.data_kr = valueObj.kr;
    },
    updateParentObject: function() {
      this.$v.$touch();

      if(this.data_cn == undefined) {
        this.data_cn = "";
      }

      if(this.data_tw == undefined) {
        this.data_tw = "";
      }

      if(this.data_ph == undefined) {
        this.data_ph = "";
      }

      if(this.data_th == undefined) {
        this.data_th = "";
      }

      if(this.data_vi == undefined) {
        this.data_vi = "";
      }

      if(this.data_id == undefined) {
        this.data_id = "";
      }

      if(this.data_my == undefined) {
        this.data_my = "";
      }

      if(this.data_jp == undefined) {
        this.data_jp = "";
      }

      if(this.data_kr == undefined) {
        this.data_kr = "";
      }

      var json = {
        en: this.data_en,
        cn: this.data_cn,
        tw: this.data_tw,
        ph: this.data_ph,
        th: this.data_th,
        vi: this.data_vi,
        id: this.data_id,
        my: this.data_my,
        jp: this.data_jp,
        kr: this.data_kr,
        vError: this.$v.$invalid
      };

      this.$emit("input", json);
    },
    reset: function() {
      this.data_en = "";
      this.data_cn = "";
      this.data_tw = "";
      this.data_ph = "";
      this.data_th = "";
      this.data_vi = "";
      this.data_id = "";
      this.data_my = "";
      this.data_jp = "";
      this.data_kr = "";
      this.teamList = [];
      // this.$v.$touch();

      this.$nextTick(() => {
        this.$v.$touch();
        this.$v.$reset();
      });
    },
    focusInput: function() {
      this.$refs.data_en.$el.focus();
    },
    validationCheck: function() {
      this.$v.$touch();
      this.updateParentObject();
    },
    resetVuelidate: function() {
      this.$v.$reset();
    },
  }
};
</script>
